import { ThirdPartyConstraintTypeBase } from './base/third-party-constraint-type-base';

export class ThirdPartyConstraintType extends ThirdPartyConstraintTypeBase { }